import { Feature } from "../../../gd/access-control/feature-access/const";
import { featureAccess } from "../../../gd/access-control/feature-access/feature-access";
import Company from "../company";


export class CompanyAccessControl {

    private company : Company

    constructor(company:Company) {
        this.company = company
    }

    // DEPRECATED
    checkFeature(feature:Feature):boolean {
        return featureAccess(feature)
    }

    get canWriteWithAI():boolean {
        // return ['U48GJt', '89d5pB', 'EiKf3E'].includes(this.company.id)
        return true
    }

    get canCreateCustomEntities():boolean {
        return ['89d5pB', 'PGUOPE','U48GJt'].includes(this.company.id)
    }

    get canCreateActions():boolean {
        // return false
        return gd.user.acl.isManager
    }

    // get canApprove():boolean {

    //     if (gd.user.acl.isManager) return true

    //     if (gd.user.acl.hasManagerAccessToUser(this.expense.userId)) return true

    //     return false
    // }




}
